import { LocaleMatch } from '../routes';
import { ClientSafeTenant } from '../../../helpcenter-data';
import { helpcenterApi } from '../../../api';
import { decodeClientSearchTerm } from '../../components-for-sections/search-input/search-input';
import { ContentFilters } from '../../utils/sdk/domain';

export const searchArticleResults = (
  brandId: string,
  locale: string,
  searchTerm: string,
  sdkContentFilters?: ContentFilters
) => {
  const maybeContentFilters = sdkContentFilters || {};
  return helpcenterApi
    .searchArticles(
      { 
        brandId,
        locale,
        text: searchTerm,
        page: 1,
        pageSize: 40,
        spellcheck: true,
        ...maybeContentFilters
      },
    )
    .then((articleList) => ({
      articles: articleList,
      search: {
        term: searchTerm,
      },
    }));
}
const loadDataClient = (
  params: LocaleMatch,
  tenant: ClientSafeTenant,
  location: any,
  initialData: any,
  baseUrl?: string,
  sdkContentFilters?: ContentFilters
) =>
  Promise.all([
    searchArticleResults(
      tenant.brandId,
      params.locale,
      decodeClientSearchTerm(new URLSearchParams(location.search).get('term') || ''),
      sdkContentFilters
    ),
  ]);

export default loadDataClient;
